import React, { useState, useEffect, useRef } from "react";
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi";
import { gsap } from "gsap";

import "./volume-slider.css";
import { useMusic } from "../../../../common/hooks";
import { VerticalSlider } from "./VerticalSlider";

export default function VolumeSlider() {
  const slider = useRef(null);
  const { volume, setVolume, isPlaying, changePlaying } = useMusic();

  const iconProps = {
    className: "volume-icon",
    color: "#ffffff",
    size: "30px",
    margin: "auto",
  };
  const [icon, setIcon] = useState(null);

  useEffect(() => {
    const showSlider = async () => {
      await gsap.to(slider.current, {
        height: !isPlaying ? "0" : "100px",
        duration: 0.1,
        ease: !isPlaying ? "sine.out" : "elastic.out(1, 0.3)",
      });
    };
    showSlider();
  }, [isPlaying]);

  useEffect(() => {
    /* Add more icons depending on the volume value */
    if (volume === 0 || !isPlaying) setIcon(<HiVolumeOff {...iconProps} />);
    else setIcon(<HiVolumeUp {...iconProps} />);
  }, [volume, isPlaying]);

  return (
    <div className="slider-container">
      <button className="volume-button" onClick={changePlaying}>
        {icon}
      </button>
      <div ref={slider} className="slider">
        <VerticalSlider value={volume} setValue={setVolume} />
      </div>
    </div>
  );
}
